import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @atlassian/i18n/no-literal-string-in-object */

import { darkPanelColors } from '../../../panel';
import { DEFAULT_BORDER_COLOR } from './common';
/** this is not new usage - old code extracted from editor-core */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
export var panelBackgroundPalette = [
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'White',
  value: '#FFFFFF'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Light blue',
  value: '#DEEBFF'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Light teal',
  value: '#E6FCFF'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Light green',
  value: '#E3FCEF'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Light yellow',
  value: '#FFFAE6'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Light red',
  value: '#FFEBE6'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Light purple',
  value: '#EAE6FF'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Light gray',
  value: '#F4F5F7'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Blue',
  value: '#B3D4FF'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Teal',
  value: '#B3F5FF'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Green',
  value: '#ABF5D1'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Yellow',
  value: '#FFF0B3'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Red',
  value: '#FFBDAD'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Purple',
  value: '#C0B6F2'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Gray',
  value: '#B3BAC5'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Dark blue',
  value: '#4C9AFF'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Dark teal',
  value: '#79E2F2'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Dark green',
  value: '#57D9A3'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Dark yellow',
  value: '#FFC400'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Dark red',
  value: '#FF8F73'
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Dark purple',
  value: '#998DD9'
}].map(function (color) {
  return _objectSpread(_objectSpread({}, color), {}, {
    border: "var(--ds-border, ".concat(DEFAULT_BORDER_COLOR, ")")
  });
});
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */

export var panelDarkModeBackgroundPalette = [
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Dark gray',
  value: darkPanelColors.DarkGray
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Dark blue',
  value: darkPanelColors.B1200S
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Dark teal',
  value: darkPanelColors.T1200S
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Dark green',
  value: darkPanelColors.G1200S
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Dark yellow',
  value: darkPanelColors.Y1200S
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Dark red',
  value: darkPanelColors.R1200S
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Dark purple',
  value: darkPanelColors.P1200S
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Gray',
  value: darkPanelColors.Gray
}, {
  label: 'blue',
  value: darkPanelColors.B900
}, {
  label: 'teal',
  value: darkPanelColors.T900
}, {
  label: 'green',
  value: darkPanelColors.G900
}, {
  label: 'yellow',
  value: darkPanelColors.Y900
}, {
  label: 'red',
  value: darkPanelColors.R900
}, {
  label: 'purple',
  value: darkPanelColors.P900
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Light gray',
  value: darkPanelColors.LightGray
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Light blue',
  value: darkPanelColors.B800S
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Light teal',
  value: darkPanelColors.T900S
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Light green',
  value: darkPanelColors.G900S
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Light yellow',
  value: darkPanelColors.Y800S
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Light red',
  value: darkPanelColors.R800S
},
// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
{
  label: 'Light purple',
  value: darkPanelColors.P800S
}].map(function (color) {
  return _objectSpread(_objectSpread({}, color), {}, {
    border: DEFAULT_BORDER_COLOR
  });
});